//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import { mapMutations } from "vuex";
import FabricInput from "@/components/q-fabric-input";
import { APP_DATETIME_SLASH } from "@/assets/js/appConfig.js";
import { getConcatLabel } from "../set-conditions";
import AQInput from "../../../Generics/AQInput/AQInput.vue";
import AQDatetime from "../../../Generics/AQDatetime/AQDatetime.vue";
import AQDropdownBadge from "../../../Generics/AQDropdownBadge/AQDropdownBadge.vue";

export default {
    components: {
        FabricInput,
        AQDatetime,
        AQInput,
        AQDropdownBadge
    },
    props: {
        value: {
            required: true,
            type: Object,
            default() {
                return {
                    type: "MOD",
                    value: "",
                    fieldType: ""
                };
            }
        },
        isReadOnly: {
            required: false,
            type: Boolean,
            default: false
        },
        filterType: {
            required: false,
            type: String,
            default: null
        },
        fromRepeatable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            locValuesArray: [
                {
                    label: this.$t("diagrams.components.emptyOpt"),
                    value: "''"
                },
                {
                    label: this.$t("diagrams.components.emptyOpt"),
                    value: null
                }
            ],
            logValuesArray: [
                {
                    label: "true",
                    value: "true"
                },
                {
                    label: "false",
                    value: "false"
                }
            ],
            floatingLabel: "",
            badgeSelected: null,
            hideInputValue: false
        };
    },
    watch: {
        value: {
            handler(newVal) {
                if (
                    newVal.type === ""
                    && newVal.fieldType === ""
                    && (newVal.value === "Gol" || newVal.value === "Empty")
                ) {
                    this.value.value = "empty";
                }
                if (newVal.type === "MOD" && newVal.value === "") {
                    this.value.value = this.floatingLabel;
                }
                if (newVal.type === "LOC" && this.filterType !== "") {
                    this.value.value = this.computedLocValue[0].value;
                }
            },
            deep: true,
            immediate: true
        },
        badgeSelected: {
            handler(newVal) {
                if (newVal && !this.isReadOnly) {
                    this.setNewType(newVal.value.toUpperCase());
                }
            },
            immediate: true
        },
        filterType: {
            handler() {
                if (this.value.type === "LOC" && this.filterType !== "") {
                    this.value.value = this.computedLocValue[0].value;
                }
            },
            immediate: true
        }
    },
    created() {
        if (this.isReadOnly && this.value.type === "MOD") {
            this.floatingLabel = this.value.value;
        }
    },
    methods: {
        ...mapMutations("rules", ["setSelectedCondition"]),
        getConcatLabel,
        onInputClick() {
            if (this.isReadOnly) {
                this.$store.commit(
                    "rules/setSelectedCondition",
                    this.floatingLabel
                );
                return;
            }
            if (this.value.type === "MOD") {
                this.$emit("showDataModel");
            } else if (this.value.type === "VAR") {
                this.$emit("showVariables");
            } else {
                this.$emit("hideSpecialIdentificators");
            }
        },
        setNewType(item) {
            this.value.type = item;
            this.value.value = "";
            this.setFieldType();
        },
        setFieldType() {
            const fieldTypes = {
                LOG: "boolean",
                LOC: "boolean",
                TXT: "string",
                DTM: "datetime",
                DATE: "date",
                TIME: "time"
            };
            if (fieldTypes.hasOwnProperty(this.value.type)) {
                this.value.fieldType = fieldTypes[this.value.type];
            } else {
                this.value.fieldType = "";
            }
        },
        setValue(newVal) {
            this.value.value = newVal;
        }
    },
    computed: {
        setDateTimeFromat() {
            return this.filterType === "datetime" ? APP_DATETIME_SLASH : "";
        },
        setConditionValue() {
            let { value } = this.value;
            if (value && (value.includes("m_") || value.includes("s_"))) {
                value = getConcatLabel(value, true).value;
            } else if (value === "empty") {
                value = this.$t("diagrams.components.empty");
            }
            return value;
        },
        setConditionPrefix() {
            let setPrefix = null;
            if (this.value.value && (this.value.value.includes("m_") || this.value.value.includes("s_"))) {
                setPrefix = getConcatLabel(this.value.value, true).prefix;
                this.hideInputValue = true;
            } else {
                this.hideInputValue = false;
            }
            return setPrefix;
        },
        computedLocValue() {
            let result = [this.locValuesArray[0]];
            if (
                this.filterType
                && (this.filterType === "integer"
                    || this.filterType === "decimal"
                    || this.filterType === "boolean")
            ) {
                result = [this.locValuesArray[1]];
            }
            return result;
        },
        isValueReadonly() {
            return this.isReadOnly || this.value.type !== "TXT";
        },
        selectOptions() {
            return this.value.type === "LOC"
                ? this.computedLocValue
                : this.logValuesArray;
        },
        getFloatingLabel() {
            if (this.floatingLabel === this.value.value) {
                return "";
            }
            return this.floatingLabel;
        },
        computedTypesArray() {
            const defaultTypes = ["MOD"];
            const otherTypes = ["LOC", "LOG", "TXT"];
            const dateTypes = {
                datetime: ["DTM"],
                date: ["DATE"],
                time: ["TIME"]
            };
            let result = [];
            if (this.fromRepeatable) {
                result = defaultTypes;
            } else {
                result = [...defaultTypes, ...otherTypes];
            }
            if (this.filterType && dateTypes.hasOwnProperty(this.filterType)) {
                result = [...defaultTypes, ...dateTypes[this.filterType]];
                if (
                    !result.includes(this.value.type)
                    && this.value.value !== "empty"
                ) {
                    this.setNewType(dateTypes[this.filterType][0]);
                }
            } else if (
                !result.includes(this.value.type)
                && this.value.value !== "empty"
            ) {
                this.setNewType("TXT");
            }
            result = result.map(str => ({ 'value': str, 'button': str }) );
            return result;
        },
        isInput() {
            return (
                (!this.isDatePicker
                    && this.isReadOnly
                    && this.value.type !== "LOC"
                    && this.value.type !== "LOG")
                || this.value.type === "MOD"
                || this.value.type === "TXT"
                || this.value.value === "empty"
                || this.value.value === "Empty"
            );
        },
        isDatePicker() {
            return (
                this.value.type === "DTM"
                || this.value.type === "DATE"
                || this.value.type === "TIME"
            );
        },
        computedBadgeSelected() {
            return {
                value: this.value.type,
                button: this.value.type
            }
        }
    }
};
